<template>
  <div class="logon">
    <div class="wrapper fadeInDown">
      <div id="formContent" class="fundo">
        <!-- Icon -->
        <div class="fadeIn first">
          <img src="@/assets/logo_sistema_sem_fundo.png" id="icon" title="VigiPlanner" />
        </div>
        <!-- Login Form -->
        <form>
          <input type="text" id="email" class="fadeIn second mt-2" :class="{'input-disabled': progress}" placeholder="E-mail" v-model="email" :disabled="progress">
          <input type="password" id="password" class="fadeIn third mt-2" :class="{'input-disabled': progress}" placeholder="Senha" v-model="passwd" :disabled="progress">
          
          <div class="text-center mt-3 mb-3 fadeIn fourth d-flex justify-content-center align-items-center">
              <label class="toggle-switch">
                <input type="checkbox" v-model="manterConectado" :disabled="progress">
                <span class="slider round" :class="{'slider-disabled': progress}"></span>
              </label>
              <span class="ml-2" style="color: #ccc; font-size: 14px; cursor: pointer;" @click="!progress && (manterConectado = !manterConectado)">
                Mantenha-me conectado
              </span>
          </div>

          <input type="button" class="fadeIn fourth mt-2" :class="{'btn-disabled': progress}" :value="progress ? 'Acessando...' : 'Acessar'" @click="fazerLogin" :disabled="progress">

          <div class="text-center mb-1 mt--3 fadeIn fourth">
            <router-link to="/login/esqueci-senha" style="font-size:13px">Esqueci minha senha</router-link> &nbsp;&nbsp;
            <router-link to="/login/cadastro" style="font-size:13px">Solicitar acesso</router-link>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
 const optionsAlert = {title: 'Usuário', size: 'sm'}

export default {
  created(){
     //redirect to https ambiance
    if(location.href.indexOf("localhost") < 0 && location.href.indexOf("https") < 0 && location.href.indexOf("192.168.0.11") < 0){
        location.href = location.href.replace("http","https");
    }
  },
  name: 'logon',
  data() {
    return {
        email : '',
        passwd : '',
        manterConectado: false,
        progress: false
    }
  },

  methods : {
    fazerLogin(){
        this.progress = true;
        this.$clubApi.post('/user/login', {
            email: this.email,
            password: this.passwd,
            rememberMe: this.manterConectado
        })
        .then((response) => {
           if (this.manterConectado) {
             localStorage.setItem("token", response.data.object);
             sessionStorage.removeItem("token");
           } else {
             sessionStorage.setItem("token", response.data.object);
             localStorage.removeItem("token");
           }
           location.href = '/home'
        }) .catch(() => {
          this.$dialogs.alert('E-mail ou senha inválido!', optionsAlert)
          this.progress = false;
        }).finally(() =>{
          // Se não redirecionou (erro), o catch já tratou o progress. 
          // Mas se for sucesso, o browser vai recarregar.
        })
    }
  }
}
</script>

<style scoped>
/* BASIC */

html {
  background-color: #4BC5A8;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #999;
  display:inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display:inline-block;
  margin: 40px 8px 10px 8px; 
  color: #cccccc;
}

.fundo {
	background-color: #392E4E !important;
}
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column; 
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 10px;
  box-sizing: border-box;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #4BC5A8;
}

/* FORM TYPOGRAPHY*/

input[type=button], input[type=submit], input[type=reset]  {
  background-color: #4b9ec5;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(106, 233, 169, 0.4);
  box-shadow: 0 10px 30px 0 rgba(130, 214, 189, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover  {
  background-color: #79e0c6;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active  {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type=text] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=password ] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
  background-color: #fff;
  border-bottom: 2px solid #4BC5A8;
}

input[type=text]:placeholder {
  color: #cccccc;
}

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after{
  width: 100%;
}

/* OTHERS */

*:focus {
    outline: none;
} 

#icon {
  width: 50%;
  margin-bottom: 20px;
  margin-top: 20px;
}

.input-disabled {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.btn-disabled {
  background-color: #999999 !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
}

/* Toggle Switch Styles */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 18px;
  margin-bottom: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #888;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #4BC5A8;
}

input:focus + .slider {
  box-shadow: 0 0 1px #4BC5A8;
}

input:checked + .slider:before {
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}

.slider-disabled {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}
</style>

